import { render } from "./DirectMessagesList.vue?vue&type=template&id=5d6fa5c8"
import script from "./DirectMessagesList.vue?vue&type=script&lang=js"
export * from "./DirectMessagesList.vue?vue&type=script&lang=js"

import "./DirectMessagesList.vue?vue&type=style&index=0&id=5d6fa5c8&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__